/**
 * 主路由 具体内容 有接口配置
 * 这里只进行页面注册
 */
export default [{
  path: '/index',
  name: 'index',
  component: () => import('@/views/index/index.vue'),
  meta: {
    title: '首页'
  }
}, {
  path: '/selection',
  name: 'selection',
  component: () => import('@/views/list/selection.vue'),
  meta: {
    title: '选品'
  }
}, {
  path: '/topic',
  name: 'topic',
  component: () => import('@/views/list/topic.vue'),
  meta: {
    title: '专题'
  }
}, {
  path: '/cart',
  name: 'cart',
  component: () => import('@/views/list/cart.vue'),
  meta: {
    title: '购物车'
  }
}, {
  path: '/goods',
  name: 'goods',
  component: () => import('@/views/detail/goods.vue'),
  meta: {
    title: '商品详情'
  }
}, {
  path: '/order',
  name: 'order',
  component: () => import('@/views/order/order.vue'),
  meta: {
    title: '购物车'
  }
}, {
  path: '/success',
  name: 'success',
  component: () => import('@/views/order/pay_success.vue'),
  meta: {
    title: '成功'
  }
}, {
  path: '/special',
  name: 'special',
  component: () => import('@/views/list/special.vue'),
  meta: {
    title: '活动专题'
  }
}, {
  path: '/about',
  name: 'about',
  component: () => import('@/views/about/index.vue'),
  meta: {
    title: '关于我们'
  }
}
, {
  path: '/coupon',
  name: 'coupon',
  component: () => import('@/views/list/coupon.vue'),
  meta: {
    title: '优惠券'
  }
}, {
  path: '/panicBuy',
  name: 'panicBuy',
  component: () => import('@/views/panic/list.vue'),
  meta: {
    title: '抢购专区'
  }
}, {
  path: '/panicDetail',
  name: 'panicDetail',
  component: () => import('@/views/panic/detail.vue'),
  meta: {
    title: '详情'
  }
}, {
  path: '/panicOrder',
  name: 'panicOrder',
  component: () => import('@/views/panic/order.vue'),
  meta: {
    title: '订单'
  }
}, {
  path: '/hotel',
  name: 'hotel',
  component: () => import('@/views/hotel/index.vue'),
  meta: {
    title: '订单'
  }
}
]
